if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSThemeConfig.custom.products_per_page,
      loadProductFirst: true,
    },
    selector: {
      avoidStickyHeader: '.site-header-sticky'
    }
  };
}

(function () {
  BoostPFS.inject(this);

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;
    var images = data.images_info;

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add classes
    itemHtml = itemHtml.replace(/{{itemGridItemWidthClass}}/g, boostPFSThemeConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{itemHoverDetailClass}}/g, boostPFSThemeConfig.custom.product_hover_details ? 'grid-product__hover-details' : '');
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, soldOut ? 'grid-product__link--disabled' : '');
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSThemeConfig.custom.quick_shop_enable && data.available ? 'grid-product__has-quick-shop' : '');
    itemHtml = itemHtml.replace(/{{itemQuickShopBtnClass}}/g, boostPFSThemeConfig.custom.quick_shop_enable ? 'quick-product__btn js-screen-open-product-{{itemId}} js-no-transition' : '');
    itemHtml = itemHtml.replace(/{{itemHref}}/g, boostPFSThemeConfig.custom.quick_shop_enable ? '' : 'href={{itemUrl}}');

    // Add labels
    var itemLabelsHtml = buildLabels(data, onSale, soldOut);
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add images
    var itemImagesHtml = buildImages(data);
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
    itemHtml = itemHtml.replace(/{{itemImageCount}}/g, images.length == 0 ? 1 : images.length);

    var itemImageStyle = '';
    if (images.length > 1) {
      var loaderDuration = 1350 * images.length;
      itemImageStyle = '<style>' +
        '.product-slider.slick-initialized[data-id="{{itemId}}"]:after {' +
        'animation-duration: ' + loaderDuration + 'ms;' +
        '}' +
        '</style>';
    }
    itemHtml = itemHtml.replace(/{{itemImageStyle}}/g, itemImageStyle);

    // Add vendor
    var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var itemReviewsHtml = boostPFSThemeConfig.custom.enable_product_reviews && boostPFSThemeConfig.custom.enable_product_reviews_collection ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    }


    // Add swatches
    var itemSwatchesHtml = buildSwatches(data);
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    return itemHtml;
  };

  function buildLabels(data, onSale, soldOut) {
    var html = '';
    var customLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        if (data.tags[i].indexOf('_label_') == 0) {
          customLabel = data.tags[i].replace('_label_', '');
        }
      }
    }
    if (customLabel) {
      html = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else if (soldOut) {
      html = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSThemeConfig.label.sold_out + '</div>';
    } else if (onSale) {
      var saleText = '';
      if (boostPFSThemeConfig.custom.product_save_amount) {
        var savedAmount = '';
        if (boostPFSThemeConfig.custom.product_save_type == 'dollar') {
          savedAmount = Utils.formatMoney(data.compare_at_price_min - data.price_min);
        } else {
          savedAmount = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min) + '%';
        }
        saleText = boostPFSThemeConfig.label.save_html.replace(/{{ saved_amount }}/g, savedAmount);
      } else {
        saleText = boostPFSThemeConfig.label.sale;
      }
      html = '<div class="grid-product__tag grid-product__tag--sale">' + saleText + '</div>';
    }
    return html;
  }

  function buildImages(data) {
    var html = '';
    var images = data.images_info;
    if (!images || images.length == 0) {
      images.push({
        src: boostPFSAppConfig.general.no_image_url,
        width: 480,
        height: 480,
        id: 0
      })
    }
    var imageLimit = boostPFSThemeConfig.custom.product_hover_image ? 10 : 1;
    images.forEach(function (image, index) {
      if (index >= imageLimit) return;
      var imageHtml = '';
      var aspectRatio = image.width / image.height;
      var imagePadding = 100 / aspectRatio;
      if (index == 0) {
        if (boostPFSThemeConfig.custom.product_grid_image_size != "natural") {
          imageHtml = '<div class="grid__image-ratio grid__image-ratio--' + boostPFSThemeConfig.custom.product_grid_image_size + ' lazyload"' +
            ' data-bgset="' + bgset(image) + '"' +
            ' data-sizes="auto">' +
            '</div>';
        } else {
          imageHtml = '<div class="image-wrap" style="height: 0; padding-bottom: ' + imagePadding + '%;">' +
            '<img class="grid-product__image lazyload"' +
            ' data-src="' + Utils.optimizeImage(image.src, '{width}x') + '"' +
            ' data-widths="[750, 900, 1080]"' +
            ' data-aspectratio="' + aspectRatio + '"' +
            ' data-sizes="auto"' +
            ' alt="{{itemTitle}}">' +
            '</div>';
        }
      } else {
        var imagePaddingStyle = boostPFSThemeConfig.custom.product_grid_image_size == "natural" ? ('style="padding-bottom: ' + imagePadding + '%"') : '';
        imageHtml = '<div class="grid__image-ratio grid__image-ratio--' + boostPFSThemeConfig.custom.product_grid_image_size + ' lazyload" ' +
          imagePaddingStyle +
          ' data-bgset="' + bgset(image) + '"' +
          ' data-sizes="auto">' +
          '</div>';
      }
      html += '<div class="product-slide">' +
        '<div class="image-wrap">' + imageHtml + '</div>' +
        '</div>';
    })
    return html;
  }

  function buildPrice(data, onSale, priceVaries) {
    var html = '';
    if (onSale) {
      html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
      html += '<del class="grid-product__price--original"><span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span></del>';
      html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      html += '<span class="money">' + boostPFSThemeConfig.label.from_text.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '</span>';
    } else {
      html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
    }
    return html;
  }

  function buildSwatches(data) {
    var html = '';
    var values = [];
    var swatchItems = [];
    if (boostPFSThemeConfig.custom.collection_color_swatches) {
      data.variants.forEach(function (variant) {
        var colorValue = '';
        variant.merged_options.forEach(function (option) {
          var key = option.split(':')[0].toLowerCase();
          var value = option.split(':')[1];
          if ((key.indexOf('color') != -1 || key.indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
            values.push(value.toLowerCase());
            colorValue = value;
          }
        });
        if (colorValue) {
          var colorImage = boostPFSAppConfig.general.asset_url.split('boost-pfs.js')[0] + Utils.slugify(colorValue) + '_50x.png';
          var colorBackground = Utils.slugify(colorValue).split('-').pop();
          var swatchItem = '<span class="color-swatch color-swatch--small" ' +
            'style="background-image: url(' + colorImage + ');' +
            ' background-color: ' + colorBackground + ';">' +
            '</span>';
          swatchItems.push(swatchItem);
        }
      })
    }
    if (swatchItems.length > 0) {
      html = '<div class="grid-product__colors">' + swatchItems.join(' ') + '</div>';
    }
    return html;
  }

  function bgset(image) {
    var bgset = '';
    if (image) {
      var aspect_ratio = image.width / image.height;

      if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
      if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
      if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
      if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
      if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
      if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
      if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
      if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
      if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
      if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
      if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
      if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
      if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
      if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
      if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
      if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
      if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
      if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
      bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
    }
    return bgset;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage <= 1) {
      return '';
    }
    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  FilterMobileButton.prototype.afterToggleFilterTree = function() {
    if (window.AOS && Settings.getSettingValue('general.filterTreeMobileStyle') === 'style1') {
      setTimeout(function() {
        AOS.refresh()
      }, 200);
    }

    if (!this.isCollapsed) {
      this.filterTree.filterOptions.forEach(filterOption => {
        if (filterOption.displayType == FilterOptionEnum.DisplayType.BOX && !filterOption.isCollapsed) {
          filterOption.filterItems.forEach(item => {
            item.setBoxItemSize();
          })
        }
      })
    }
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    // Add quick view modal
    if (boostPFSThemeConfig.custom.quick_shop_enable) {
      document.getElementById('ProductScreens').innerHTML = '';
      this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function (results) {
        let count = results.length - 1;
        results.forEach(function (result, index) {
          document.getElementById('ProductScreens').innerHTML = document.getElementById('ProductScreens').innerHTML + result.quickview;
          if (jQ('#ProductScreen-' + result.id).length == 0) {
            jQ('[data-boost-theme-quickview="' + result.id + '"]').append(result.quickview);
          }
          if (index == count && window.theme &&
            typeof theme.reinitProductGridItem == 'function' &&
            typeof theme.QuickShopScreens.reInit == 'function' &&
            typeof theme.sections.reinit == 'function') {
            theme.sections.reinit('collection-grid');
            let newBoostPFSProductContent = document.getElementById('js-boost-pfs-filter-products-ajax-content');
            theme.reinitProductGridItem(newBoostPFSProductContent);
            theme.QuickShopScreens.reInit(newBoostPFSProductContent);

          }
        });
      });
    } else {
      if (window.theme &&
        typeof theme.reinitProductGridItem == 'function' &&
        typeof theme.sections.reinit == 'function') {
        let newBoostPFSProductContent = document.getElementById('js-boost-pfs-filter-products-ajax-content');
        theme.sections.reinit('collection-grid');
        theme.reinitProductGridItem(newBoostPFSProductContent);
      }
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
  };
})();
